export const setCookie = (c_name, value, exdays = 30) => {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? ";path=/" : ";path=/;expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
}

export const getCookie = (c_name) => {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}
// All search engines + lighthouse - /woobot|speed|ighth|tmetr|eadle|bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(navigator.userAgent);
// Just lighthouse speed insights - /woobot|speed|ighth|tmetr|eadle/
export const isGoogleCrawler = () =>  /woobot|speed|ighth|tmetr|eadle/i.test(navigator.userAgent);

export const isDirectLink = !document.referrer || document.referrer === '' || (!document.referrer.includes('tinytap.com') && !document.referrer.includes('tinytap.it'));

export function getURLParameter(key) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key)
}